module.exports = __webpack_public_path__ + "img/album18_04.ccfdb2eb.jpg";